import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[idpFlyoutPosition]',
  standalone: true
})
export class FlyoutPositionDirective implements OnInit {
  @Input() headerSelector = '.header__top';
  @Input() alignToSelector = 'idp-search-wrapper';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.setPosition();
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > 991) {
      this.setPosition();
    }
  }

  private setPosition(): void {
    const headerElement = document.querySelector(this.headerSelector);
    const alignElement = document.querySelector(this.alignToSelector);

    this.renderer.addClass(this.el.nativeElement.parentElement, '!justify-end');
    this.renderer.addClass(this.el.nativeElement.parentElement, '!items-start');

    if (headerElement) {
      this.renderer.setStyle(this.el.nativeElement, 'top', '54px');
    }

    if (alignElement) {
      const alignRect = alignElement.getBoundingClientRect();
      this.renderer.setStyle(
        this.el.nativeElement,
        'right',
        `${window.innerWidth - alignRect.right - 44}px`
      );
    }
  }
}
